import { type FeatureModule } from '@store/features/types';
import storage from 'redux-persist/lib/storage';

import ehrExtensionPromoReducer from './slice';

export const ehrExtensionPromoFeature: FeatureModule = {
  id: 'ehrExtensionPromo',
  name: 'EHR Extension Promo',
  dependencies: [],
  reducers: {
    ehrExtensionPromo: ehrExtensionPromoReducer,
  },
  middleware: [],
  persistence: {
    enabled: true,
    storage: storage,
    whitelist: [
      'dismissed',
      'snoozedUntil',
      'homeBannerDismissed',
      'homeBannerSnoozedUntil',
    ],
    debounce: 300,
  },
  sync: {
    enabled: true,
    whitelist: [
      'dismissPromo',
      'snoozePromo',
      'dismissHomeBanner',
      'snoozeHomeBanner',
    ],
  },
  setup: _store => {},
  cleanup: _store => {},
};
